import { Link } from "react-aria-components";
import styles from "./styles.module.sass";

interface RetryScanButtonProps {
  onPress(): void;
  isDisabled?: boolean;
}

export function RetryScanButton({ onPress, isDisabled }: RetryScanButtonProps) {
  return (
    <Link onPress={onPress} isDisabled={isDisabled} className={styles.retry}>
      Scan again
    </Link>
  );
}
